import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { FiscalHomePill } from '../../models';

/**
 * Píldora de la cabecera del Home (diseño «homeCta: píldora»): invita a activar o muestra el estado
 * del trámite y lleva a Fiscal. El Home decide si se pinta (dueño + flag); aquí solo se dibuja.
 */
@Component({
    selector: 'fina-fiscal-home-pill',
    templateUrl: './fiscal-home-pill.component.html',
    styleUrls: ['./fiscal-home-pill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiscalHomePillComponent {
    @Input() pill: FiscalHomePill | null = null;
    @Output() pick = new EventEmitter<FiscalHomePill>();
}
